module.exports = "https://web-assets.ifttt.com/packs/media/header/discover-5c329ee3.svg";